<template>
  <div class="auth">
    <router-link to="/m/login">Log In</router-link>
    or
    <router-link to="/m/register">Sign Up</router-link>
  </div>
</template>

<script>
export default {
  name: 'auth',
};
</script>

<style>
.auth {
  margin: 0 auto;
  width: 460px;
}
</style>
